import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfigLoaderService {
   
  private configs: IConfiguration;
  private http: HttpClient;

  constructor(private readonly httpHandler: HttpBackend) {
    this.http = new HttpClient(httpHandler);
  }
  
  get Configuration() : IConfiguration {
    return this.configs;
  } 
  
  loadConfigs() : Promise<boolean> {

    return new Promise<boolean>((resolve, reject) => {
        this.http.get('assets/configuration.json').pipe(map(res => res))
          .subscribe(value => {
            this.configs = value as IConfiguration;
            resolve(true);
          },
          (error) => {
            reject(error);
          });
      });
     
    // return this.http.get('assets/configuration.json').pipe(settings => settings)
    //   .toPromise()
    //   .then(settings => {
    //     this.configs = settings as IConfiguration; 
    //   });
  }
}
export interface IConfiguration {
  msal: MsalConfiguration,
  azFunctions: AzFunctionsConfiguration
}

export class MsalConfiguration{
    clientId: string;
    authority: string;
    redirectUri: string;
    postLogoutRedirectUri: string;
    defaultScope: string;
}

export class AzFunctionsConfiguration{
    baseUrl: string;
    defaultScope: string;
}

export function appInitializerFactory(configsLoaderService: ConfigLoaderService) {
    return () => configsLoaderService.loadConfigs(); 
  }